import React, { useEffect, useRef, useState } from 'react';
import { BrowserMultiFormatReader } from '@zxing/browser';

export default function Scanner({ open, onDetected, onClose }) {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);
  const intervalRef = useRef(null);

  const [status, setStatus] = useState('Initialisation caméra…');
  const [scanning, setScanning] = useState(false);

  // 📷 démarrage caméra
  useEffect(() => {
    if (!open) return;

    const startCamera = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: 'environment' },
          audio: false,
        });

        streamRef.current = stream;
        videoRef.current.srcObject = stream;

        await videoRef.current.play();

        setStatus('Scan automatique actif 📡');
        startAutoScan();
      } catch (e) {
        console.error(e);
        setStatus('❌ Caméra indisponible');
      }
    };

    startCamera();

    return () => stopAll();
  }, [open]);

  // 🧼 stop total
  const stopAll = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    if (streamRef.current) {
      streamRef.current.getTracks().forEach(t => t.stop());
      streamRef.current = null;
    }
  };

  // ❌ fermer
  const handleClose = () => {
    stopAll();
    onClose();
  };

  // 🔁 scan auto
  const startAutoScan = () => {
    if (intervalRef.current) return;

    intervalRef.current = setInterval(scanFrame, 700); // ⚡ vitesse scan
  };

  // 📸 analyse image
  const scanFrame = async () => {
    if (scanning) return;

    setScanning(true);

    try {
      const video = videoRef.current;
      const canvas = canvasRef.current;

      if (!video || video.readyState < 2) {
        setScanning(false);
        return;
      }

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      const reader = new BrowserMultiFormatReader();
      const result = await reader.decodeFromCanvas(canvas);

      if (result) {
        // 📳 vibration
        if (navigator.vibrate) {
          navigator.vibrate([100, 50, 100]);
        }

        stopAll();
        onDetected(result.getText());
      }
    } catch (e) {
      // normal si aucun code trouvé
    }

    setScanning(false);
  };

  if (!open) return null;

  return (
    <div className="scanfs open">

      {/* 📷 caméra */}
      <video
        ref={videoRef}
        autoPlay
        playsInline
        muted
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          pointerEvents: 'none',
        }}
      />

      {/* 🧠 canvas caché */}
      <canvas ref={canvasRef} style={{ display: 'none' }} />

      {/* UI */}
      <div className="scan-ui">
        <div className="scan-frame">
          <div className="sline" />
        </div>
        <div className="scan-lbl">{status}</div>
      </div>

      {/* ❌ fermer */}
      <button className="scan-close-btn" onClick={handleClose}>
        ✕ Fermer
      </button>

    </div>
  );
}